angular.module('FlexyBeautyApp.services')
    .constant('Genders', {
        MAN: {label: 'Homme'},
        WOMAN: {label: 'Femme'},
        OTHER: {label: 'Autre'}
    });



// WEBPACK FOOTER //
// ./js/constants/Gender.js